<template>
  <div class="container">
    <!--登录页面-->
    <div class="dengl">
      <div class="dly">
        <div class="dlyt fl"><img src="@/view/images/y75.jpg" /></div>
        <div class="dlyw fr">
          <div class="dlywa">
            <h6>欢迎登录印工社</h6>
            <p>
              <a href="javascript:void(0);" @click="codepage">验证码登录</a>
            </p>
          </div>
          <div class="dlywb">
            <div class="dlywb_a">
              <p>账号</p>
              <input
                class="input1"
                type="text"
                v-model.number="mobile"
                placeholder="请输入您的手机号"
              />
            </div>
            <div class="dlywb_a">
              <p>密码</p>
              <input
                class="input1"
                type="password"
                v-model.trim="password"
                placeholder="请输入您的密码"
              />
            </div>
            <div class="dlywb_a" style="display: none">
              <p>验证码</p>
              <div class="dlywb_yz">
                <input
                  class="input2 fl"
                  type="text"
                  v-model.trim="code"
                  placeholder="请输入验证码"
                />
                <img class="tb fr" src="@/view/images/sx.png" />
                <img class="ta fr" src="@/view/images/yzm.png" />
                <div class="clearfix"></div>
              </div>
            </div>
            <div class="dlywb_b">
              <input type="submit" @click="submitlogin" value="登录" />
            </div>
          </div>
          <div class="dlywc">
            <p class="fl">
              <a href="javascript:void(0);" @click="register">注册帐号</a>
            </p>
            <p class="fr">
              <a href="javascript:void(0);" @click="forget">忘记密码</a>
            </p>
            <div class="clearfix"></div>
          </div>
          <div class="dlywd">
            <p>
              登录即表示已同意本平台<a href="#">《印工用户社服务协议》</a>和<a
                href="javascript:void(0)"
                @click="privacy"
                >《隐私政策声明》</a
              >
            </p>
          </div>
        </div>
      </div>
      <div class="yjd">
        <p>
          Copyright© 2019-2021 印工社（青岛）数字科技有限公司 All Rights
          Reserved<span>|</span><a
            href="https://beian.miit.gov.cn"
            target="_banck"
            style="corsor:pointer"
          >
            鲁ICP备20000134号-3</a
          ><span></span><a href="https://beian.mps.gov.cn/#/query/webSearch?code=37021402002207\" target="_banck">鲁公网安备 37021402002207号</a><span class="span1">|</span>网站建设：<a href="#"
            >印工社</a
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import cookies from '@/utils/cookie.js';

export default {
  name: 'loginName',
  data() {
    return {
      mobile: '',
      password: '',
      code: '',
    };
  },
  methods: {
    init() {},
    privacy() {
      this.$router.push({ path: '/privacy' });
    },
    register() {
      this.$router.push({ path: '/register' });
    },
    forget() {
      this.$router.push({ path: '/forget' });
    },
    codepage() {
      this.$router.push({ path: '/codepohone' });
    },
    submitlogin() {
      const _this = this;
      const { mobile } = _this;
      const { password } = _this;
      if (mobile === '') {
        this.$message.error('手机号不能为空');
        return false;
      }
      if (!/^1[3456789]\d{9}$/.test(mobile)) {
        this.$message.error('手机号格式错误');
        return false;
      }
      if (password === '') {
        this.$message.error('密码不能为空');
        return false;
      }
      if (password.length > 16 < 6) {
      } else {
        this.$message.error('请输入6-16位密码，支持数字字母下划线');
        return false;
      }
      const prams = {
        phone: mobile,
        password,
        type: 'SUP',
      };
      const url = `${process.env.API_HOST}/psl/user/login`; // HOME变量为已挂载的可跨域域名，这里将其拼接完，成为一个完整路径
      this.$axios({
        // this代表vue对象，之前在入口文件中把axios挂载到了vue中，所以这里直接用this.$axios调用axios对象
        url,
        method: 'post',
        data: prams,
      }).then((res) => {
        const json = res.data;
        if (json.message.success) {
          _this.$notify({
            title: '提示',
            message: json.message.message,
            type: 'success',
          });
          const token = json.message.data;
          cookies.set('token', token);
          setTimeout(() => {
            window.open(`${press.env.VUE_APP_USERCONSOLE}/HomePage`, '_self');
            // _this.$router.push({ path: "/" });
          }, 2000);
        } else {
          _this.$notify({
            title: '提示',
            message: json.message.message,
            type: 'error',
          });
        }
      });
    },
  },
  mounted() {},
  created() {
    this.init();
  },
};
</script>

<style scoped>
.container {
  background-color: #273142;
  width: 100%;
  height: 100vh;
}

.dengl .yjd {
  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/view/login.vue